var FORBIDDEN_EMAIL_REGEX = [/^(.*@testuser.qa.cian.ru)$/i, /^(.*Emls@cian.ru)$/i, /^(.*@social.cian.ru)$/i];
export function isEmail(value) {
  return /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i.test(value);
}
export function isAllowedEmail(value) {
  if (!isEmail(value)) {
    return false;
  }
  return !FORBIDDEN_EMAIL_REGEX.some(function (regex) {
    return regex.test(value);
  });
}